




































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { APP_CONFIG } from '@/config/app-config';

import { PayAuthorityModel } from '@/models/payauthority';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailPayAuthority extends Vue {
    @Prop({default: null})
    private payauthority!: PayAuthorityModel;
}
